import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/v1`,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    Accept: "application/json",
  },
});

export const createApiWithPath = (apiPath: string = "v1") => {
  const newApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL}/${apiPath}`,
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Accept: "application/json",
    },
  });

  // Copy authentication headers from main api instance
  if (api.defaults.headers.common.Authorization) {
    newApi.defaults.headers.common.Authorization =
      api.defaults.headers.common.Authorization;
  }

  return newApi;
};

// TODO: use query
export const createURLParams = (params: any): string => {
  return `?${new URLSearchParams(params).toString()}`;
};

export default api;
